var React = require('react');

function IconNonimg (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M24.69 24.5l-6.9-6.9-3.044-3.044-9.179-9.175-1.6-1.6L2.285 2.1.69 3.7 3.3 6.321v14.9a2.27 2.27 0 0 0 2.263 2.263h14.9l2.62 2.616zM5.567 21.223V8.584l7.74 7.74-.95 1.188-2.263-3.078L6.7 18.96h9.245l2.263 2.263zm3.2-15.842L6.506 3.118h14.9a2.27 2.27 0 0 1 2.263 2.263v14.9l-2.263-2.263V5.381z","transform":"translate(-0.69 -2.1)"}));
}

IconNonimg.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconNonimg;

IconNonimg.default = IconNonimg;
